/**
 * Ochrana před double klikem na submit tlačítko
 * Stačí přidat na form atribut data-prevent-double-form-submit
 * První část je pro formuláře bez ajaxu druhá pro AJAX formuláře
 */

import { disableVanillaSubmit } from './parts/utils';

export default function () {
	$.nette.ext('prevent-double-form-submit', {
		before: function (xhr, settings) {
			if (
				!settings.nette ||
				!settings.nette.form ||
				settings.nette.form[0].dataset.preventDoubleFormSubmit === undefined
			) {
				return;
			}

			settings.nette.el[0].disabled = true; // nastavení disabled pro odesílací tlačítko
		},
		complete: function (jqXHR, status, settings) {
			if (
				!settings.nette ||
				!settings.nette.form ||
				settings.nette.form[0].dataset.preventDoubleFormSubmit === undefined
			) {
				return;
			}

			settings.nette.el[0].disabled = false; // vrácení stavu zpět
		}
	});
}
